<template>
  <div class="plan">
    <condition />
    <course :editable=editable />
    <plan-price />
    <control />
  </div>
</template>

<script>
import Condition from '../components/organisms/Condition'
import Course from '../components/organisms/Course'
import Control from '../components/organisms/Control'
import PlanPrice from '../components/organisms/PlanPrice'

export default {
  components: {
    Condition,
    Course,
    Control,
    PlanPrice
  },
  created () {
    if (!this.$route.params.fromMap) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('condition/resetDetailOptions')
      this.$store.dispatch('places/fetchAll')
        .then(() => {
          this.$store.dispatch('genres/fetchAll')
            .then(() => {
              if (this.poiId) {
                  const place = this.$store.getters['places/getPlace'](this.$route.params.poiId)
                  if (place) {
                    this.$store.dispatch('destinations/buildDestinations', [Object.assign(place, { lock: true })])
                    this.$store.dispatch('plans/updateTitle', place.name + this.$t('tour_course_label'))
                    this.$store.dispatch('routes/search')
                  } else {
                    this.$store.dispatch('places/fetchPlace', this.poiId).then((poi) => {
                      const g = Object.values(poi.tags)[0]
                      const icon = g && g.img ? g.img : ''
                      const fetchPlace = {
                        id: poi.poi_id,
                        name: poi.shop_name,
                        name_yomi: poi.shop_name_yomi,
                        location: {
                          latitude: parseFloat(poi.latitude),
                          longitude: parseFloat(poi.longitude)
                        },
                        address: poi.address,
                        genreIds: Object.keys(poi.tags),
                        genreWords: Object.values(poi.tags),
                        image: poi.img_main,
                        detail: poi.shop_introduction,
                        zipcode: poi.zipcode,
                        accessDetails: poi.access_details,
                        phoneNumber: poi.phone_number,
                        businessHour: poi.business_hours,
                        regularHoliday: poi.regular_holiday,
                        url: poi.url,
                        mapIcon: icon,
                        benefits: poi.benefits,
                        priority: poi.priority,
                        distance: poi.distance
                      }
                    this.$store.dispatch('destinations/buildDestinations', [Object.assign(fetchPlace, { lock: true })])
                    this.$store.dispatch('plans/updateTitle', fetchPlace.name + this.$t('tour_course_label'))
                    this.$store.dispatch('routes/search')
                  })
                }
              }
              this.$store.dispatch('loading/endLoading')
            })
        })
      if (this.courseId) {
        this.$store.dispatch('loading/beginLoading')
        this.$store.dispatch('courses/fetchAll')
          .then(() => {
            const course = this.$store.getters['courses/getCourse'](this.courseId)
            this.$store.dispatch('destinations/buildDestinations', course.places)
            this.$store.dispatch('plans/updateTitle', course.title)
            if (course.defaultDepatureStation !== undefined) {
              this.$store.dispatch('destinations/updateDepartureStation', course.defaultDepatureStation)
            }
            if (course.defaultArrivalStation !== undefined) {
              this.$store.dispatch('destinations/updateArrivalStation', course.defaultArrivalStation)
            }
            if (course.defaultDepartureStationCode !== undefined) {
              this.$store.dispatch('destinations/updateDepartureStationCode', course.defaultDepartureStationCode)
            }
            if (course.defaultArrivalStationCode !== undefined) {
              this.$store.dispatch('destinations/updateArrivalStationCode', course.defaultArrivalStationCode)
            }
            this.$store.dispatch('routes/search')
          })
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      }
    }
  },
  props: {
    courseId: {
      type: Number
    },
    poiId: {
      type: Number
    }
  },
  data () {
    return {
      editable: true
    }
  }
}
</script>
